import React, { useState } from 'react';
import { createContext } from 'react';

export const AttachmentsContext = createContext();
export const SetAttachmentsContext = createContext();

const Provider = ({ children }) => {
  const [attachments, setAttachments] = useState([]);

  const addFile = (file) => {
    setAttachments((prev) => [...prev, file]);
  };

  const removeFile = (index) => {
    const newFiles = attachments.filter((_, i) => i !== index);

    setAttachments(newFiles || []);
  };

  const resetFiles = () => {
    setAttachments([]);
  };

  return (
    <AttachmentsContext.Provider value={attachments}>
      <SetAttachmentsContext.Provider
        value={{ addFile, removeFile, resetFiles }}
      >
        {children}
      </SetAttachmentsContext.Provider>
    </AttachmentsContext.Provider>
  );
};

export default Provider;
